import type { Edge, Node } from '@xyflow/react';
import type { HandleDefinition, OutputsResolver, WidgetNodeData } from '../../widgets/types';

export function pruneNodeEdges(edges: Edge[], nodeId: string, outputs: HandleDefinition[] | undefined) {
  if (!outputs) return edges;

  const ids = new Set(outputs.map((h) => h.id));
  const kept = edges.filter((e) => e.source !== nodeId || ids.has(e.sourceHandle ?? ''));
  return kept.length === edges.length ? edges : kept;
}

export function pruneOrphanedEdges(nodes: Node<WidgetNodeData>[], edges: Edge[], outputsFor: OutputsResolver) {
  const kept = nodes.reduce((acc, n) => pruneNodeEdges(acc, n.id, outputsFor(n.type ?? '', n.data.config)), edges);
  const keptIds = new Set(kept.map((e) => e.id));

  return {
    edges: kept,
    pruned: edges.filter((e) => !keptIds.has(e.id)),
  };
}
